/* Keep the native drawer's accessibility and overlay state in sync on all close paths. */
document.addEventListener('toggle', (event) => {
  const drawer = event.target;
  if (!(drawer instanceof HTMLDetailsElement) || !drawer.matches('.header--jupityr-drawer #Details-menu-drawer-container')) return;
  drawer.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(drawer.open));
}, true);

/* Native focus restoration can scroll to the header's document position after
   body scroll locking ends. Keep the customer's place when either drawer closes. */
(() => {
  const drawerStates = new WeakMap();
  const observer = new MutationObserver((records) => {
    for (const { target } of records) {
      if (!(target instanceof Element)) continue;
      const isMenu = target.matches('#Details-menu-drawer-container');
      const isCart = target.matches('cart-drawer');
      if (!isMenu && !isCart) continue;
      const open = isMenu ? target.open : target.classList.contains('active');
      const previous = drawerStates.get(target);
      if (open && !previous?.open) {
        drawerStates.set(target, { open: true, scrollTop: window.scrollY });
      } else if (!open && previous?.open) {
        drawerStates.set(target, { ...previous, open: false });
        requestAnimationFrame(() => {
          if (document.querySelector('#Details-menu-drawer-container[open], cart-drawer.active')) return;
          const stickyHeader = document.querySelector('sticky-header');
          if (stickyHeader) stickyHeader.currentScrollTop = previous.scrollTop;
          window.scrollTo({ top: previous.scrollTop, behavior: 'instant' });
        });
      }
    }
  });
  const observeDrawers = () => {
    document.querySelectorAll('#Details-menu-drawer-container, cart-drawer').forEach(drawer => {
      observer.observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
    });
  };
  observeDrawers();
  document.addEventListener('shopify:section:load', observeDrawers);
})();
